import React from 'react'
import {Divider as ChakaraDivider, DividerProps} from '@chakra-ui/react'

export const Divider = (props: DividerProps) => {
  return <ChakaraDivider {...props}></ChakaraDivider>
}
export default Divider
